import React, { useState, useContext } from "react";
import PropType from "prop-types";
import "../PlayerTableRow/PlayerTableRow.css";
import "./PlayerExposureRow.css";
import { GreenMachineContext } from "../../GreenMachineContext";

import { ReactComponent as ClosedLock } from "../../../../../../assets/icons/closed-lock.svg";
import { ReactComponent as OpenLock } from "../../../../../../assets/icons/open-lock.svg";

export default function PlayerExposureRow(props) {
  const { numLineups } = useContext(GreenMachineContext);

  const playerName = props.player.slatePlayer.player.shortenedName;

  const exposureValue =
    props.player.id in props.sessionChanges
      ? props.sessionChanges[props.player.id]
      : props.player.exposure;

  function saveNewExposure(newExposure) {
    if (newExposure < 0 || newExposure > numLineups) {
      return;
    }

    const exposureChecked = isNaN(exposureValue) ? 0 : exposureValue;

    props.updateUnsavedSelections(
      props.player.id,
      newExposure,
      props.player.slatePlayer.salary,
      newExposure - exposureChecked
    );
  }

  function lockPlayer(e) {
    e.preventDefault();
    saveNewExposure(numLineups);
  }

  function unlockPlayer(e) {
    e.preventDefault();
    saveNewExposure(0);
  }

  function incrementExposure(e) {
    e.preventDefault();
    saveNewExposure(exposureValue + 1);
  }

  function decrementExposure(e) {
    e.preventDefault();
    saveNewExposure(exposureValue - 1);
  }

  return (
    <tr className={"gm-player-table-row-unselected"}>
      <td className="gm-exposure-table-cell">
        <div className="gm-player-table-cell-name">
          <strong>{props.player.slatePlayer.position}</strong> {playerName}
          {props.player.slatePlayer.suffix ? (
            <> ({props.player.slatePlayer.suffix})</>
          ) : null}{" "}
          <strong>${props.player.slatePlayer.salary}</strong>
        </div>
        <div className="gm-player-table-cell-team">
          {props.player.slatePlayer.player.team
            ? props.player.slatePlayer.player.team.abbreviation
            : null}
        </div>
        {props.player.slatePlayer.gupPercProj !== null ? (
          <div className="gm-player-table-cell-start">
            <strong>
              Gup&apos;s Proj Own: {props.player.slatePlayer.gupPercProj}%
            </strong>
          </div>
        ) : (
          <div className="gm-player-table-cell-start">
            {props.player.slatePlayer.slateCompetition.prettyStartTime}
          </div>
        )}
        {props.player.slatePlayer.projPoints !== null ? (
          <div className="gm-player-table-cell-start">
            <strong>Proj Points: {props.player.slatePlayer.projPoints}</strong>
          </div>
        ) : null}
      </td>
      <td className="gm-exposure-table-cell-actions">
        <div className="gm-exposure-table-exposure-buttons">
          <div
            className="gm-exposure-table-increment"
            role="button"
            tabIndex={0}
            onClick={(e) => {
              incrementExposure(e);
            }}
            onKeyPress={(e) => {
              incrementExposure(e);
            }}
          />
          <div
            className="gm-exposure-table-decrement"
            role="button"
            tabIndex={0}
            onClick={(e) => {
              decrementExposure(e);
            }}
            onKeyPress={(e) => {
              decrementExposure(e);
            }}
          />
        </div>
        <div className="gm-exposure-table-value">
          <input
            type="number"
            className="gm-exposure-table-value-input"
            value={exposureValue}
            onChange={(e) => {
              let checkedExposure = isNaN(exposureValue) ? 0 : exposureValue;
              let change = parseInt(e.target.value) - checkedExposure;

              if (isNaN(change)) {
                change = checkedExposure * -1; // NaN is effectively 0, so remove exposureValue amount of selections
              }

              props.updateUnsavedSelections(
                props.player.id,
                parseInt(e.target.value),
                props.player.slatePlayer.salary,
                change
              );
            }}
          />
          <p className="gm-exposure-table-value-perc">
            {!isNaN(exposureValue)
              ? Math.round((exposureValue / numLineups) * 100)
              : 0}
            %
          </p>
        </div>

        {exposureValue === numLineups ? (
          <ClosedLock
            className="gm-exposure-table-lock-button"
            fill="#77dd77"
            onClick={unlockPlayer}
          />
        ) : (
          <OpenLock
            className="gm-exposure-table-lock-button"
            fill="#ff6961"
            onClick={lockPlayer}
          />
        )}
      </td>
    </tr>
  );
}

PlayerExposureRow.propTypes = {
  player: PropType.object.isRequired,
};
